<div class="legal-container">

  <!-- Header Principal -->
  <div class="legal-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-scale-balanced"></i>
        <div class="header-text">
          <h1>Dictamen Legal del Arrendamiento</h1>
          <p class="header-subtitle">Registra el dictamen legal del arrendamiento</p>
        </div>
      </div>
      <div class="header-right">
        <p-tag *ngIf="isRegistered()" value="Registrado" severity="success" icon="pi pi-check-circle"></p-tag>
        <p-tag *ngIf="!isRegistered()" value="Pendiente" severity="warning" icon="pi pi-clock"></p-tag>
      </div>
    </div>
  </div>

  <!-- Grid Resumen + Formulario -->
  <div class="legal-grid">

    <!-- Resumen (lado izquierdo) -->
    <div class="info-card summary-sticky">
      <div class="card-header">
        <i class="fa-solid fa-scale-balanced text-blue-600"></i>
        <h3>Resumen del Dictamen</h3>
      </div>
      <div class="card-content">
        <div class="summary-amount-card">
          <div class="amount-label">Calificación</div>
          <div class="amount-value">
            {{ data?.legal?.score != null ? data?.legal?.score : '—' }}<span class="amount-suffix" *ngIf="data?.legal?.score != null"> / 100</span>
          </div>

          <div class="amount-breakdown">
            <div class="breakdown-item">
              <span class="breakdown-label">Estado:</span>
              <span class="breakdown-amount">{{ isRegistered() ? 'Registrado' : 'Pendiente' }}</span>
            </div>
            <div class="breakdown-item">
              <span class="breakdown-label">Documento:</span>
              <span class="breakdown-amount">{{ isRegistered() ? 'Adjunto' : 'Sin documento' }}</span>
            </div>
          </div>

          <div class="notes-preview" *ngIf="data?.legal?.notes">
            <div class="notes-title"><i class="pi pi-align-left"></i> Observaciones</div>
            <p class="notes-text">{{ data?.legal?.notes }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulario (lado derecho) -->
    <form [formGroup]="e" (ngSubmit)="save()" class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-file-pen text-blue-600"></i>
        <h3>Datos del Dictamen</h3>
      </div>
      <div class="card-content">
        <div class="legal-form">

          <!-- Calificación -->
          <div class="field field-flex">
            <label for="score">*Calificación (1-100):</label>
            <p-inputNumber formControlName="score" inputId="score" [min]="1" [max]="100" [useGrouping]="false" placeholder="Ingresa una calificación del 1 al 100"></p-inputNumber>
            <ng-container *ngIf="e.get('score')?.invalid && (e.get('score')?.dirty || e.get('score')?.touched)">
              <small class="p-error" *ngIf="e.get('score')?.errors?.['required']">La calificación es obligatoria.</small>
              <small class="p-error" *ngIf="e.get('score')?.errors?.['min']">El valor mínimo es 1.</small>
              <small class="p-error" *ngIf="e.get('score')?.errors?.['max']">El valor máximo es 100.</small>
            </ng-container>
          </div>

          <!-- Documento -->
          <div class="field">
            <app-input-single-file
              label="Documento del dictamen"
              (fileUrl)="onFileSelected($event)"
              (fileDeleted)="onFileDeleted()"
              (downloadRequested)="onDownloadRequested($event)"
              [tooltip]="'Documento del dictamen legal'"
              [documentName]="'legalDictamen'"
              [folder]="'legal'"
              [id]="leaseDetailService.id"
              [fileUrlValue]="leaseDetailService.data?.legal?.file">
            </app-input-single-file>
          </div>

          <!-- Observaciones -->
          <div class="field field-flex">
            <label for="notes">Observaciones (opcional):</label>
            <textarea pInputTextarea formControlName="notes" id="notes" rows="3" placeholder="Notas u observaciones del dictamen legal"></textarea>
          </div>

        </div>
        <div class="legal-action">
          <!-- El dictamen es EDITABLE aun despues de registrado: Legal puede corregir
               su calificacion/observaciones/documento. El boton solo se bloquea si el
               form es invalido (score 1-100 + documento). El estado "Registrado" se
               sigue mostrando en el tag del header. -->
          <button
            pButton
            pRipple
            [label]="isRegistered() ? 'Actualizar dictamen' : 'Guardar'"
            [icon]="isRegistered() ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-check'"
            class="p-button-success p-button-lg"
            type="submit"
            [disabled]="e.invalid"
            [style.width]="'100%'"></button>
        </div>
      </div>
    </form>

  </div>
</div>

<p-toast position="top-right"></p-toast>
